import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-configuracoes',
  standalone: false,
  templateUrl: './configuracoes.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './configuracoes.component.css'
})
export class ConfiguracoesComponent {
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ConfiguracoesComponent>) { }

  close() {
    this.dialogRef.close();
  }
}
